module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/fm-dog-1920.10280b6ff5af5275.jpg"+" 1920w",
        images: [{path: "https://static.sniffspot.com/packs/img/fm-dog-1920.10280b6ff5af5275.jpg",width: 1920,height: 1331}],
        src: "https://static.sniffspot.com/packs/img/fm-dog-1920.10280b6ff5af5275.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/fm-dog-1920.10280b6ff5af5275.jpg"},
        
        width: 1920,
        height: 1331
      }